import script from "./NewsPageAside.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageAside.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageAside.vue?vue&type=style&index=0&id=647157ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-647157ba"]])

export default __exports__